<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">培训证明</h3>
        <div class="tabs">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item>
              <el-select v-model="form.name" placeholder="请选择证书名称" clearable>
                <el-option
                  v-for="(item,i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.print" placeholder="是否允许打印" clearable>
                <el-option label="是" value="shanghai"></el-option>
                <el-option label="否" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            highlight-current-row
            :header-cell-style="{background:'#dde9fc',color:'#606266'}"
          >
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="name" label="客户姓名" min-width="80"></el-table-column>
            <el-table-column prop="province" label="性别" min-width="80"></el-table-column>
            <el-table-column prop="city" label="身份证号" min-width="200"></el-table-column>
            <el-table-column prop="address" label="证书名称" min-width="150"></el-table-column>
            <el-table-column prop="Q" label="总学时" min-width="80"></el-table-column>
            <el-table-column prop="S" label="已完成学时" min-width="100"></el-table-column>
            <el-table-column prop="D" label="完成状态" min-width="100"></el-table-column>
            <el-table-column prop="F" label="是否允许打印" min-width="100"></el-table-column>
            <el-table-column prop="RR" label="完成时间" min-width="100"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">打印</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pageSize"
            :total="totalCount"
            :page-count="totalPage"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="prevPage"
            @next-click="nextPage"
            layout="total, sizes,prev, pager, next,  jumper"
          ></el-pagination>
        </div>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";

export default {
  name: "record",
  data() {
    return {
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      // pageIndex: 1,
      pageSize: 10, // 每页显示个数
      totalPage: 10, // 总页数
      totalCount: 20, // 总条目数
      currentPage: 1, // 当前页
      form: {
        name: "",
        print: ""
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1517 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1519 弄",
          zip: 200333
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        }
      ]
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
    handleClick(row) {
      console.log(row);
    },
    // 每页数
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 上一页
    prevPage() {
      console.log("上一页");
    },
    // 下一页
    nextPage() {
      console.log("下一页");
    }
  }
};
</script>
<style lang="less" scoped>
.cont {
  border-radius: 6px;
  width: 100%;
  margin: 30px 0;
  background: #ffffff;
  .title {
    font-size: 18px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 30px;
    font-weight: normal;
  }
}
.tabs {
  padding: 30px;
}
</style>
